import React, { useEffect, useState } from "react";
import Layouts from "../../components/Layouts";
import { Button, Modal, Space, Table, Tag } from "antd";
import { getDirectusClient } from "../../lib/directus";
import { Link } from "react-router-dom";
import { readItems, updateItem, updateItems } from "@directus/sdk";
import { useSelector } from "react-redux";



function Traslados(props) {
  const [modal, setModal] = useState(false);
  const [seriales, setSeriales] = useState([]);
  const userBodega = useSelector((state) => state.userdata);
  const columns = [
    {
      title: "Bodega",
      dataIndex: "bodega",
      key: "bodega",
      render: (record) => {
        return <p>{record.nombre}</p>;
      },
    },
    {
      title: "Bodega destino",
      dataIndex: "bodega_destino",
      key: "bodega_destino",
      render: (record) => {
        return <p>{record.nombre}</p>;
      },
    },
    {
      title: "Estado",
      dataIndex: "estado",
      key: "estado",
      render: (record) => {
        return (
          <Tag
            color={
              record == "anulado"
                ? "red"
                : record == "creado"
                ? "black"
                : "green"
            }
          >
            {record}
          </Tag>
        );
        console.log(record.first_name);
      },
    },
    {
      title: "Creado por",
      dataIndex: "user_created",
      key: "user_created",
      render: (record) => {
        return <p>{record.first_name}</p>;
        console.log(record.first_name);
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              consultarseriales(record.id);
              setModal(true);
            }}
          >
            Ver seriales
          </Button>
          <a
            onClick={() => {
              Aceptartraslado(record.id, false);
            }}
          >
            Anular Traslado
          </a>
        </Space>
      ),
    },
  ];

  const Aceptartraslado = (id) => {
    let aceptar = true;
    consultarseriales(id, aceptar);
  };
  const cerrarModal = () => {
    setModal(false);
  };

  const consultarseriales = async (id, aceptar) => {
    const directus = await getDirectusClient();

    if (aceptar) {
      try {
        const serialesData = await directus.request(
          readItems("seriales", {
            fields: ["id", "serial"],
            filter: {
              solicitud_traslado: {
                solicitud_traslado_id: { _eq: id }
              },
              bodega: { id: { _eq: userBodega.bodega.id }}
            }
          })
        );

        Modal.confirm({
          title: "¿Quieres anular este traslado de seriales?",
          content: `Se anulará el traslado de ${serialesData.length} seriales`,
          async onOk() {
            try {
              // Update seriales status and location - Note the changes here
              await directus.request(
                updateItems(
                  "seriales",
                  serialesData.map((serial) => serial.id), // Array of IDs
                  {
                    estado: 1,
                    bodega: userBodega.bodega.id,
                    solicitud_traslado: null,
                  }
                )
              );

              // Update traslado status
              await directus.request(
                updateItem("solicitud_traslado", id, {
                  estado: "anulado",
                })
              );

              const historialIds = await directus.request(
                readItems('historial_traslado', {
                  fields: ['id'],
                  filter: {
                    serial: {
                      _in: serialesData.map(s => s.id)
                    }
                  }
                })
              );
  
              if (historialIds.length > 0) {
                await directus.request(
                  updateItems('historial_traslado',
                    historialIds.map(h => h.id),
                    {
                      estado: "anulado",
                      anulado_por: userBodega.id,
                      aceptado_fecha: null,
                      acaptado_por: null
                    }
                  )
                );
              }

              Modal.success({
                title: "Éxito",
                content: `Se anuló el traslado. ${serialesData.length} seriales permanecen en la bodega original`,
              });

              consultaTraslados();
            } catch (error) {
              console.error("Error:", error);
              Modal.error({
                title: "Error",
                content: "No se pudo anular el traslado",
              });
            }
          },
        });
      } catch (error) {
        console.error("Error getting serials:", error);
      }
    } else {
      await directus.request(
        readItems("seriales", {
          fields: ["*"],
          limit: -1,
          filter: {
            solicitud_traslado: {
              solicitud_traslado_id: { _eq: id }
            },
            bodega: { id: { _eq: userBodega.bodega.id }}
          }
        })
      ).then((seriales) => {
        setSeriales(seriales);
      });
    }
  };

  const [traslados, setTraslados] = useState([]);

  const consultaTraslados = async () => {
    const directus = await getDirectusClient();

    try {
      const response = await directus.request(
        readItems("solicitud_traslado", {
          fields: [
            "id",
            "estado",
            "bodega.id",
            "bodega.nombre",
            "bodega_destino.id",
            "bodega_destino.nombre",
            "user_created.first_name",
            "date_created"
          ],
          // filter: {
          //   _or: [
          //     { bodega: { id: { _eq: userBodega.bodega.id }}},
          //     { bodega_destino: { id: { _eq: userBodega.bodega.id }}}
          //   ]
          // }
        })
      );

      setTraslados(response);
    } catch (error) {
      console.error("Error fetching traslados:", error);
    }
  };

  useEffect(() => {
    consultaTraslados();
  }, []);
  return (
    <Layouts>
      <Link to={"/nuevo-traslado"}>
        <Button>Crear traslado </Button>
      </Link>
      <Link to={"/aceptar-traslado"}>
        <Button>Aceptar traslado traslado </Button>
      </Link>
      <Table columns={columns} dataSource={traslados} />
      <Modal onOk={cerrarModal} onCancel={cerrarModal} open={modal}>
        {seriales.map((serial) => {
          return (
            <Space size={"small"}>
              <p>{"- " + serial.serial} </p>
            </Space>
          );
        })}
      </Modal>
    </Layouts>
  );
}

export default Traslados;
